import React from 'react';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import ArrowRightAltIcon from '@mui/icons-material/ArrowRightAlt';
import CancelIcon from '@mui/icons-material/Cancel';
import { grey, lightGreen, red } from '@mui/material/colors';
import { useWatch } from 'react-hook-form';
import { LenderFieldMap } from '@trnsact/trnsact-shared-types';

interface Props {
  field: LenderFieldMap;
}

export const MappingStatusIcon = ({ field }: Props) => {
  const mappedValue = useWatch({
    name: `mappingsByLenderFieldId.${field.lenderFieldId}.mappedValue`,
  });

  const isMapped = !!mappedValue || mappedValue === 0;
  const hasErrors = !!field.details?.errors?.length;

  if (!isMapped) {
    return (
      <>
        <CancelIcon sx={{ color: grey[400] }} />
        <ArrowRightAltIcon sx={{ color: grey[400] }} />
      </>
    );
  }

  return (
    <>
      {hasErrors ? (
        <>
          <CancelIcon sx={{ color: red[500] }} />
          <ArrowRightAltIcon sx={{ color: grey[400] }} />
        </>
      ) : (
        <>
          <CheckCircleIcon sx={{ color: lightGreen[500] }} />
          <ArrowRightAltIcon sx={{ color: lightGreen[500] }} />
        </>
      )}
    </>
  );
};
